var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.global.screenWidth < 700)?_c('div',{class:{ slideinNav: _vm.showNav },attrs:{"id":"topNav"}},[_c('MobileNav')],1):_c('div',{class:{ slideinNav: _vm.showNav },attrs:{"id":"topNav"}},[_c('PrimaryNav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }